import React from 'react'

function WorkshopsComp() {
  return (
    <div className='instructorComponent'>
        WorkshopsComp
    </div>
  )
}

export default WorkshopsComp